;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { useState, FormEvent } from "react"
import MUIDialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import DialogTitleAndClose from "./DialogTitleAndClose"
import { styled, useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import SubmitPaymentButton from "./SubmitPaymentButton"
import updateErrorMessage from "../../../../../graphql/mutations/snackbarMessage/updateErrorMessage"
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js"
import { UI_STYLE_PRIMARY_FONT } from "../../../../../lib/constants"

const BootstrapDialog = styled(MUIDialog)(() => ({
  "& .MuiDialog-paper": {
    backgroundColor: "#E7EAEC",
    border: "5px solid #E4FF3F",
    "@media only screen and (min-width: 600px)": {
      borderRadius: "20px",
      border: "9px solid #E4FF3F",
    },
  },
  "& .MuiDialogContent-root": {
    display: "flex",
    flexDirection: "column",
    fontFamily: UI_STYLE_PRIMARY_FONT,
    padding: "10px 24px",
    "@media only screen and (min-width: 600px)": {
      padding: "16px 24px",
    },
  },
  "& .MuiDialogActions-root": {
    "@media only screen and (min-width: 600px)": {
      padding: "10px 24px 10px 24px",
    },
  },
}))

type Props = {
  onClose: () => Promise<void> | void
}

export default function AddPaymentMethodDialog({ onClose }: Props) {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))
  const stripe = useStripe()
  const elements = useElements()
  const [isPaymentElementReady, setPaymentElementReady] = useState(false)

  const handleClose = async () => {
    await onClose()
  }

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()

    if (!stripe || !elements || !isPaymentElementReady) {
      return
    }

    const { error } = await stripe.confirmSetup({
      elements,
      confirmParams: {},
      redirect: "if_required",
    })

    if (error) {
      updateErrorMessage(error.message ?? "Failed to add card.")
      return
    }

    await handleClose()
  }

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={true}
      fullWidth={true}
      maxWidth={"sm"}
      fullScreen={fullScreen}
    >
      <DialogTitleAndClose title={"Add Payment Method"} onClose={onClose} />
      <DialogContent
        sx={{
          fontFamily: UI_STYLE_PRIMARY_FONT,
        }}
      >
        <form onSubmit={handleSubmit}>
          <PaymentElement onReady={() => setPaymentElementReady(true)} />
        </form>
      </DialogContent>
      <DialogActions
        sx={{
          margin: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <SubmitPaymentButton
          disabled={!stripe || !isPaymentElementReady}
          onClick={handleSubmit}
        />
      </DialogActions>
    </BootstrapDialog>
  )
}
